import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private modals: { [key: string]: BehaviorSubject<boolean> } = {};

  constructor() {}

  // Register a modal with a unique identifier
  registerModal(id: string): void {
    if (!this.modals[id]) {
      this.modals[id] = new BehaviorSubject<boolean>(false);
    }
  }

  // Open a specific modal
  openModal(id: string): void {
    if (this.modals[id]) {
      this.modals[id].next(true);
    }
  }

  // Close a specific modal
  closeModal(id: string): void {
    if (this.modals[id]) {
      this.modals[id].next(false);
    }
  }

  // Get the open/close state of a specific modal
  getModalState(id: string): Observable<boolean> {
    if (!this.modals[id]) {
      this.registerModal(id);
    }
    return this.modals[id].asObservable().pipe(distinctUntilChanged());
  }
}
